<h2 mat-dialog-title class="text-lg font-bold mb-1">{{ id ? 'Editar Registro' : 'Nuevo Registro' }}</h2>
<mat-dialog-content class="modal-content">
  <form #listPriceForm="ngForm">
    <div class="grid grid-cols-2 gap-4">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Organización Ventas</mat-label>
        <mat-select [(ngModel)]="currentPriceList.distributionChainId" name="distributionChainId" required>
          @for (item of salesOrganizationList; track item) {
          <mat-option [value]="item._id">
            {{ item.name}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
     <!--  <mat-form-field appearance="fill" class="w-full">
        <mat-label>Lista de Precios</mat-label>
        <mat-select [(ngModel)]="currentPriceList.field4" name="field4" required>
          <mat-option>
            <ngx-mat-select-search [(ngModel)]="searchPriceList" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="changueOptionsPriceList($event)" placeholderLabel="Buscar precio de lista..."
              noEntriesFoundLabel="No se encontraron resultados">
            </ngx-mat-select-search>
          </mat-option>
          @for (price of listFilterPriceList; track price) {
          <mat-option [value]="price._id">
            <b>{{price.code}}</b> - {{price.name}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field> -->
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Rango</mat-label>
        <mat-select [(ngModel)]="currentPriceList.rangeId" name="rangeId">
            @for (item of rangeList; track item) {
            <mat-option [value]="item.code">
                {{ item.name}}
            </mat-option>
            }
        </mat-select>                    
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Material</mat-label>
        <mat-select [(ngModel)]="currentPriceList.itemId" name="itemId" (selectionChange)="getUnitMeasureList()"
          required>
          <mat-option>
            <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
              noEntriesFoundLabel="No se encontraron resultados">
            </ngx-mat-select-search>
          </mat-option>
          @for (item of materialList; track item) {
          <mat-option [value]="item._id">
            <b>{{ item.code }}</b> - {{ item.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Unidad Medida</mat-label>
        <mat-select [(ngModel)]="currentPriceList.unitMeasureId" name="unitMeasureId" required>
          @for (unit of unitMeasureList; track unit) {
          <mat-option [value]="unit.unitOfMeasure?._id">
            <b>{{unit.unitOfMeasure?.code}}</b> - {{unit.unitOfMeasure?.name}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Moneda</mat-label>
        <mat-select [(ngModel)]="currentPriceList.currencyId" name="currencyId" required>
          @for (currency of listFilterCurrency; track currency) {
          <mat-option [value]="currency._id">
            <b>{{currency.code}}</b> - {{currency.name}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Precio</mat-label>
        <input matInput type="number" [(ngModel)]="currentPriceList.price" name="price" required>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Desde/Hasta</mat-label>
        <mat-date-range-input [formGroup]="rangePriceList" [rangePicker]="picker">
          <input matStartDate formControlName="start" placeholder="Fecha Inicio">
          <input matEndDate formControlName="end" placeholder="Fecha Fin">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </form>
  @if(false){
  <app-table-price-list [data]="currentPriceList"
    (materialPriceChange)="updateFormPriceList($event)"></app-table-price-list>
  }
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-between">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSubmit()"
    [disabled]="!listPriceForm.valid || !rangePriceList.valid">Guardar</button>
</mat-dialog-actions>